import {AppBar, Grid, Paper, Tab, Tabs, useMediaQuery} from "@material-ui/core";

import React, {Component, Fragment} from "react";
import json2mq from "json2mq";

import Result, {Viewer3D, SaveResult} from "./result";
import Containers from "./containers";
import Items from "./items";
import Risks from "./risks";

var mode = "";
var fullscreen = false;

export function MainWindow({root}) {
    var desktopWidth = useMediaQuery(json2mq({minWidth: 1500}));
    var listWidth = useMediaQuery(json2mq({minWidth: 1300}));
    if (desktopWidth) {
        listWidth = false;
        }
    var mobileWidth =  !(desktopWidth || listWidth);

    if (!fullscreen) {
        if (desktopWidth) {
            mode = "desktop";
            }
        if (listWidth) {
            mode = "list";
            }
        if (mobileWidth) {
            mode = "mobile";
            }
        }

    return <MainWindow2 root={root} mode={mode} />;
    }

class MainWindow2 extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {fullscreen: false};
        }

    shouldComponentUpdate = () => {
        //console.log("shouldComponentUpdate", !this.state.fullscreen);
        return !this.state.fullscreen;
        }

    setFullscreen = (newVal) => {
        //console.log("setFullscreen", newVal);
        fullscreen = newVal;
        //this.state.fullscreen = newVal;
        //this.setState({fullscreen: newVal});
        }

    render = () => {
        var {mode, root} = this.props;

        return <Fragment>
            {mode == "desktop" && <DesktopMain root={root} setFullscreen={this.setFullscreen} />}
            {mode == "list" && <ListMain root={root} setFullscreen={this.setFullscreen} />}
            {mode == "mobile" && <MobileMain root={root} setFullscreen={this.setFullscreen} />}
        </Fragment>;
        }
    }

function DesktopMain({root, setFullscreen})  {
    return <Fragment>
            <Result solution={root.state.solution}
                    containers={root.state.dspContainers}
                    mode="desktop"
                    setFullscreen={setFullscreen}
                    height={500}
                    viewerUrl={root.state.viewerUrl}
                    apiUrl={root.state.apiUrl}
                    root={root} />
            <Grid container spacing={2}>
                <Grid item xs={5}>
                    <Items onUpdate={root.updateItems} data={root.state.items} simplified={root.state.simplified} dangerous={root.state.dangerous} axis={root.state.axis} />
                </Grid>

                <Grid item xs={7}>
                    <Containers onUpdate={root.updateContainers} data={root.state.containers} simplified={root.state.simplified} dangerous={root.state.dangerous} axis={root.state.axis} />

                    {root.state.dangerous &&
                        <Risks onUpdate={root.updateRisks} data={root.state.risks}  />}
                </Grid>
            </Grid>
        </Fragment>;
    }

function ListMain ({root, setFullscreen}){

    return <Fragment>
            <Result solution={root.state.solution}
                    containers={root.state.dspContainers}
                    mode="list"
                    setFullscreen={setFullscreen}
                    height={"70vh"}
                    viewerUrl={root.state.viewerUrl}
                    apiUrl={root.state.apiUrl}
                    root={root}/>

            <Items onUpdate={root.updateItems} data={root.state.items} simplified={root.state.simplified} dangerous={root.state.dangerous} axis={root.state.axis} />
            <Containers onUpdate={root.updateContainers} data={root.state.containers} simplified={root.state.simplified} dangerous={root.state.dangerous} axis={root.state.axis}/>
        {root.state.dangerous && <Risks onUpdate={root.updateRisks} data={root.state.risks} /> }

        </Fragment>;
    }

class MobileMain extends Component {
    constructor(props, context) {

        super(props, context);
        var state = {
            activeTab: 0
            };

        this.state = state;

        }

    handleChange = (event, newValue) => {
        this.setState({activeTab: newValue});
        }

    saveResult = () => {
        this.myRef.current.toGlb();
        }

    render = () => {
        var {root, setFullscreen} = this.props;

        if (this.state.activeTab == 2) {
            document.getElementById("viewport").setAttribute("content", "width=device-width, height=device-height, initial-scale=1");
            }

        return <Fragment>
            <AppBar position="static" color="secondary">
                <Tabs value={this.state.activeTab} onChange={this.handleChange}>
                    <Tab label="Items" />
                    <Tab label="Containers" />
                    <Tab label="Results" />
                    {root.state.dangerous && <Tab label="Risks" /> }

                </Tabs>
            </AppBar>

            {(this.state.activeTab == 2) &&
                <Fragment>
                    <Paper>
                        <Viewer3D solution={root.state.solution}
                                  containers={root.state.dspContainers}
                                  mode="mobile"
                                  setFullscreen={setFullscreen}
                                  height={"80vh"}
                                  viewerUrl={root.state.viewerUrl}/>

                    </Paper>
                    <p></p>
                    <Paper>
                        <SaveResult
                            viewerUrl={root.state.viewerUrl}
                            apiUrl={root.state.apiUrl}
                            root={root} />
                    </Paper>
                </Fragment>
                }

            {(this.state.activeTab == 3) &&
                <Risks onUpdate={root.updateRisks} data={root.state.risks} simplified={root.state.simplified} dangerous={root.state.dangerous}/>
                }

            {(this.state.activeTab == 1) &&
                <Containers onUpdate={root.updateContainers} data={root.state.containers} simplified={root.state.simplified} dangerous={root.state.dangerous} axis={root.state.axis}/>
                }

            {(this.state.activeTab == 0) &&
                <Items onUpdate={root.updateItems} data={root.state.items} simplified={root.state.simplified} dangerous={root.state.dangerous} axis={root.state.axis} />
                }

        </Fragment>;
        }
    }

export default MainWindow;
